import React from 'react';
import PropTypes from 'prop-types';
import ReCAPTCHA from 'react-google-recaptcha';

export default function ReduxCAPTCHA({ input, ...rest }) {
	return (
		<ReCAPTCHA
			{...rest}
			size="normal"
			{...input}
		/>
	);
}

ReduxCAPTCHA.propTypes = {
	input: PropTypes.object,
};
